var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"id":"AppSnackbar","app":"","top":_vm.top,"centered":_vm.centered,"bottom":_vm.bottom,"left":_vm.left,"color":_vm.color},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }